import { AxiosInstance } from 'axios';
import EventAttendantRepositoryInterface, {
  CreateEventAttendantInterface,
  EventAttendantInterface,
  UpdateEventAttendantInterface,
} from '@/services/Calendar/EventAttendant/Interfaces';

export default class EventAttendantRepository implements EventAttendantRepositoryInterface {
  private apiPrefix = '/event-calendar/event';

  constructor(
    private axios: AxiosInstance,
  ) {
  }

  async getAllAttendantsForEvent(eventId: number): Promise<EventAttendantInterface[]> {
    const res = await this.axios.get(`${this.apiPrefix}/${eventId}/attendant`);

    return res.data;
  }

  async getAttendantForEvent(eventId: number, attendantId: number): Promise<EventAttendantInterface> {
    const res = await this.axios.get(`${this.apiPrefix}/${eventId}/attendant/${attendantId}`);

    return res.data;
  }

  async createAttendantForEvent(data: CreateEventAttendantInterface): Promise<boolean> {
    const res = await this.axios.post(`${this.apiPrefix}/${data.eventId}/attendant`, data);

    return res.status === 201;
  }

  async updateAttendantForEvent(data: UpdateEventAttendantInterface): Promise<void> {
    await this.axios.patch(`${this.apiPrefix}/${data.eventId}/attendant`, data);
  }

  async deleteAttendantForEvent(eventId: number, attendantId: number): Promise<void> {
    await this.axios.delete(`${this.apiPrefix}/${eventId}/attendant`, { data: { id: attendantId } });
  }
}
